//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// event-scheduler-description-input imports
import { IProps, IState } from "./EventSchedulerDescriptionInput.d";
import * as s from "./EventSchedulerDescriptionInput.styles";
// material-ui
import { TextField } from "@material-ui/core";
import { Subject } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";
import classnames from "classnames";

//////////////////
// COMPONENT
//////////////////
class EventSchedulerDescriptionInputCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      editMode: false,
      description: props.description || "",
    };
  }

  private expand = (expand: boolean) => {
    this.setState({ editMode: expand });
  };

  private onDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const description = event.target.value;
    this.setState({ description });
    if (this.props.onChange) {
      this.props.onChange(description);
    }
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { description } = this.state;

    return (
      <div
        className={classnames([this.props.classes.container, "fs-mask"])}
        onClick={() => this.expand(true)}
      >
        <Subject {...s.subjectIcon} />
        <TextField
          placeholder="Add description"
          InputProps={{
            disableUnderline: true,
          }}
          multiline
          fullWidth
          value={description}
          onChange={this.onDescriptionChange}
          cw-id="event-scheduler-description-input"
        />
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const EventSchedulerDescriptionInput = withStyles(s.styles)(
  EventSchedulerDescriptionInputCmpt,
);
